/**
 * Marquee — infinite scrolling brand statement ticker. Pure CSS animation.
 */
export default function Marquee({
  items = [],
  accent = "#F68712",
  testId = "marquee",
  speed = 60, // seconds for one full loop
}) {
  // Duplicate the list so the scroll loop is seamless
  const loop = [...items, ...items];

  return (
    <div
      className="relative overflow-hidden bg-[#0A192F] border-y border-white/10 py-5"
      data-testid={testId}
    >
      <div
        className="flex items-center whitespace-nowrap animate-bb-marquee"
        style={{ animationDuration: `${speed}s` }}
      >
        {loop.map((item, i) => (
          <span
            key={i}
            className="flex items-center mx-6 font-extrabold tracking-tight text-xl sm:text-2xl lg:text-3xl text-white"
          >
            {item}
            <span
              className="ml-6 w-2 h-2 rotate-45"
              style={{ backgroundColor: accent }}
              aria-hidden="true"
            />
          </span>
        ))}
      </div>

      {/* Edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-12 sm:w-24 bg-gradient-to-r from-[#0A192F] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-12 sm:w-24 bg-gradient-to-l from-[#0A192F] to-transparent" />
    </div>
  );
}
